import { render, staticRenderFns } from "./PostBoostingWithoutConnect.vue?vue&type=template&id=3c26677b&scoped=true&"
import script from "./PostBoostingWithoutConnect.vue?vue&type=script&lang=ts&"
export * from "./PostBoostingWithoutConnect.vue?vue&type=script&lang=ts&"
import style0 from "./PostBoostingWithoutConnect.vue?vue&type=style&index=0&id=3c26677b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c26677b",
  null
  
)

export default component.exports